import { render } from "./RecipeGenerate.vue?vue&type=template&id=1b8f9ada&scoped=true"
import script from "./RecipeGenerate.vue?vue&type=script&lang=js"
export * from "./RecipeGenerate.vue?vue&type=script&lang=js"

import "./RecipeGenerate.vue?vue&type=style&index=0&id=1b8f9ada&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b8f9ada"]])

export default __exports__